declare namespace $ {

	type $mol_view__sub_shm_remove_menu_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_remove_menu_2 = $mol_type_enforce<
		ReturnType< $shm_remove_menu['menu_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_remove_menu_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_remove_menu_4 = $mol_type_enforce<
		ReturnType< $shm_remove_menu['remove_yes_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_remove_menu_5 = $mol_type_enforce<
		ReturnType< $shm_remove_menu['remove_accept'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_remove_menu_6 = $mol_type_enforce<
		ReturnType< $shm_remove_menu['remove_no_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_remove_menu_7 = $mol_type_enforce<
		ReturnType< $shm_remove_menu['remove_cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_remove_menu_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_remove_menu_9 = $mol_type_enforce<
		ReturnType< $shm_remove_menu['remove_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_remove_menu_10 = $mol_type_enforce<
		ReturnType< $shm_remove_menu['remove_confirm'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_remove_menu_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_remove_menu extends $mol_pick {
		Menu_trigger_icon( ): $mol_icon_dots_vertical
		Menu_trigger( ): $mol_view
		menu_rows( ): readonly(any)[]
		Menu( ): $mol_view
		remove_confirm( next?: any ): any
		Remove_text( ): $mol_view
		remove_accept( next?: any ): any
		Remove_yes( ): $mol_button_minor
		remove_cancel( next?: any ): any
		Remove_no( ): $mol_button_minor
		Confirm_actions( ): $mol_view
		align( ): string
		remove_confirmed( next?: boolean ): boolean
		remove( next?: any ): any
		remove_title( ): string
		remove_confirm_title( ): string
		remove_yes_title( ): string
		remove_no_title( ): string
		trigger_content( ): readonly(any)[]
		bubble_content( ): readonly(any)[]
		Remove_button( ): $mol_button_minor
		Confirm( ): $mol_view
	}
	
}

//# sourceMappingURL=menu.view.tree.d.ts.map